module.exports = __webpack_public_path__ + "static/media/title.d3bc0368.png";